// 存档迁移骨架（EP-002-S4 / ADR-002 §2.4）。
// 约定：
//  - from === to：直接原样返回（无迁移）。
//  - from === 0 && to === 1：未实现，抛 "migrate v0→v1 not yet implemented"（保留为 MVP 之前的占位）。
//  - from === 1 && to === 2：补 mailbox=[] + lastPostcardNoteIdByDestination={}（P-POSTCARD-RECONCEIVE v2）。
//  - 其它组合：抛 "unknown migration"。
import { CURRENT_SCHEMA_VERSION } from './constants';

interface SaveShapeLike {
  schemaVersion?: unknown;
  mailbox?: unknown;
  lastPostcardNoteIdByDestination?: unknown;
}

export function migrate(raw: unknown, from: number, to: number): unknown {
  if (from === to) return raw;
  if (from === 0 && to === 1) {
    throw new Error('migrate v0→v1 not yet implemented');
  }
  if (from === 1 && to === 2) {
    return migrateV1ToV2(raw);
  }
  if (from === to - 1) {
    throw new Error(`migrate v${from}→v${to} not yet implemented`);
  }
  throw new Error(`unknown migration: from v${from} to v${to}`);
}

function migrateV1ToV2(raw: unknown): unknown {
  if (typeof raw !== 'object' || raw === null) {
    throw new Error('migrate v1→v2: raw 不是对象');
  }
  const obj = raw as SaveShapeLike;
  // 不可变地构造新对象（避免破坏持久化字节）
  return {
    ...(raw as Record<string, unknown>),
    schemaVersion: CURRENT_SCHEMA_VERSION,
    mailbox: Array.isArray(obj.mailbox) ? obj.mailbox : [],
    lastPostcardNoteIdByDestination:
      typeof obj.lastPostcardNoteIdByDestination === 'object' && obj.lastPostcardNoteIdByDestination !== null
        ? obj.lastPostcardNoteIdByDestination
        : {},
  };
}
